var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTmMove = function SvgTmMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.5 1.042h-5c-4.525 0-6.458 1.933-6.458 6.458v5c0 4.525 1.933 6.458 6.458 6.458h5c4.525 0 6.459-1.933 6.459-6.458v-5c0-4.525-1.934-6.458-6.459-6.458m-5 16.666c-3.841 0-5.208-1.366-5.208-5.208v-5c0-3.842 1.367-5.208 5.208-5.208h5c3.842 0 5.209 1.366 5.209 5.208v5c0 3.842-1.367 5.208-5.209 5.208z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.5 6.558H8.4A3.197 3.197 0 0 0 5.208 9.75 3.197 3.197 0 0 0 8.4 12.942h5.641a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625H8.4A1.944 1.944 0 0 1 6.458 9.75c0-1.075.867-1.942 1.942-1.942h4.1a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.858 10.4a.62.62 0 0 0-.441.183.63.63 0 0 0 0 .884l.866.866-.866.867a.63.63 0 0 0 0 .883.63.63 0 0 0 .883 0l1.308-1.308a.63.63 0 0 0 0-.883L13.3 10.583a.66.66 0 0 0-.442-.183"
  })));
};
export default SvgTmMove;